import React, { Component } from 'react';
import { Grid, Row, Col, Image } from 'react-bootstrap';
import './final.css';
import okCircle from '../../resources/images/ok-circle.svg';
import { connect } from "react-redux";
import config from "../../config/config";
import TitleComponent from '../../components/title/TitleComponent';
import MainButton from '../../components/buttons/main_button/MainButton';

const RETAIL_COMPANY_ID = parseInt(config.retail_company_id);
const AF_PUBLIC_URL = config.af_public_url;

class Final extends Component {

    constructor(props) {
        super(props);
        this.redirectToAfPublic = this.redirectToAfPublic.bind(this);
    }

    redirectToAfPublic = () => {
        const customUrl = this.props.stepInfo.externData;
        return window.location.href = `${AF_PUBLIC_URL}${customUrl}`;
    }

    getFinalMessage = () => {
        let showButton = false;
        if (this.props.stepInfo && this.props.stepInfo.message) {
            return (
                <p className={'description'}>{this.props.stepInfo.message}</p>
            );
        } else {
            if (this.props.source !== 'TRANSFERENCE') {
                return (
                    <>
                        <p className={'description'}>¡Has tomado la firma con éxito! Ya puedes cerrar esta ventana.</p>
                    </>
                );
            } else {
                if (this.props.stepInfo.company_id && this.props.stepInfo.company_id === RETAIL_COMPANY_ID) {
                    return (
                        <>
                            <p className={'description'}>Has finalizado tu firma y ahora pasa a la etapa de revisión. Luego de esto verás la firma estampada en tu contrato.</p>
                            <strong>Puedes regresar a revisar el estado de tu transferencia</strong>
                            {showButton && <div className={'fullwidth'}>
                                <MainButton
                                    onClick={this.redirectToAfPublic}
                                    text={'Ir a la transferencia'}
                                ></MainButton>
                            </div>}
                        </>
                    );
                }

                return (
                    <p className={'description'}>
                        Has finalizado tu firma y ahora pasa a la etapa de revisión. El avance ahora depende de la firma de todas las partes involucradas y de la aprobación del contrato por parte del aprobador del proceso.
                        <br></br>
                        <br></br>
                        <strong>Puedes cerrar esta ventana</strong>
                    </p>
                );
            }
        }
    }

    render() {
        let title = 'PROCESO';
        if (this.props.stepInfo.externData && this.props.stepInfo.externData != null) {
            title = `PROCESO #${this.props.stepInfo.externData}`
        }
        return (
            <div className={'final'}>
                <Grid>
                    <Row className={'container-content'}>
                        <Col xs={12} className={'content'}>
                            <Image
                                src={okCircle}
                                className={'ok-circle-image-bullet'}
                            />
                            <TitleComponent bolder black className={'text-center'}>El proceso ha finalizado con éxito</TitleComponent>
                            {this.getFinalMessage()}
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        code: state.code,
        stepInfo: state.stepInfo,
        stepData: state.stepData,
        source: state.source,
    };
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Final);
